// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-msg[data-v-a93eac76]{font-size:12px;height:20px;line-height:20px;color:#d46161;font-weight:500}.error-msg--bold[data-v-a93eac76]{font-weight:600}.error-msg .handler[data-v-a93eac76]{font-weight:700;color:#69f;cursor:pointer}", ""]);
// Exports
module.exports = exports;
